import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@pma/components/common/alert-dialog"
import { Button } from "@pma/components/common/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "@pma/components/common/tooltip"
import useTranslator from "@pma/hooks/use-translator"
import { RotateCcw } from "lucide-react"
import React, { Fragment, useContext, useEffect, useState } from "react"
import { GroupedTasksContext } from "./context/GroupedTasksProvider"
import { useAuth } from "@pma/stores/auth-store"

interface Props {
  group: any
  onClose?: Function
}

const RestoreTaskGroup = ({ group }: Props) => {
  const { translate } = useTranslator()
  const { authConfig } = useAuth()

  const { restoreTaskGroupMutation } = useContext(GroupedTasksContext)
  const [isOpen, setIsOpen] = useState(false)

  const handleRestore = (groupId: any) => {
    if (!groupId) return

    restoreTaskGroupMutation?.mutate({
      groups_id: [groupId],
      organization_id: authConfig?.last_organization_id,
    })
  }

  useEffect(() => {
    if (!restoreTaskGroupMutation?.isPending && restoreTaskGroupMutation?.isSuccess) {
      onClose()
    }
  }, [restoreTaskGroupMutation?.isPending])

  const onClose = () => {
    setIsOpen(false)
  }

  return (
    <Fragment>
      <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
        <Tooltip>
          <TooltipTrigger>
            <AlertDialogTrigger>
              <Button variant={"ghost"} className='h-6 w-7 text-xs' size={"icon"}>
                <RotateCcw size={16} />
              </Button>
            </AlertDialogTrigger>
          </TooltipTrigger>
          <TooltipContent>{translate("Restore Task Group")}</TooltipContent>
        </Tooltip>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {translate("Proceed to restore")} {group?.name}?
            </AlertDialogTitle>
            <AlertDialogDescription>
              {translate("This group will be restored from trash")}.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={onClose}>{translate("Cancel")}</AlertDialogCancel>
            <Button
              disabled={restoreTaskGroupMutation?.isPending}
              loading={restoreTaskGroupMutation?.isPending}
              onClick={() => handleRestore(group.id)}
            >
              {translate("Continue")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Fragment>
  )
}

export default RestoreTaskGroup
